import { Component } from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { CustomCellRendererParams, IconDetail, IconType } from './etl-custom-cell-value-renderer.model';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'cv-etl-custom-cell-value-renderer',
    templateUrl: './etl-custom-cell-value-renderer.component.html',
    styleUrls: ['./etl-custom-cell-value-renderer.component.scss']
})
export class EtlCustomCellValueRendererComponent implements AgRendererComponent {

    params: ICellRendererParams;
    value: string;
    searchFilter: string;
    minSearchLength = 1;
    highlightedText: string;
    iconType = IconType;
    iconDetail: IconDetail;
    showValuePopover: boolean;

    agInit(params: CustomCellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
        if(!params.node.group) {
            // Check if the iconPath method exists or not, since there could be only
            // few rows that will have a status icon displayed along with the value.
            // In such case the function will be undefined, and directly calling it
            // will cause the whole grid to fail.
            if (typeof params?.iconPath === "function") {
                this.iconDetail = params?.iconPath(params.data);
            }
            this.showValuePopover = params.showTextPopover;
            if (typeof params?.convertedValue === "function") {
                this.value = params?.convertedValue(params.data);
            }
        }
    }

    refresh(params: ICellRendererParams) {
        this.params = params;
        this.value = params.valueFormatted != null ? params.valueFormatted : params.value;
        this.searchFilter = this.params.context?.getFilterText();
        return true;
    }

    showPopover(ngbPopover: PopoverDirective) {
        if(this.iconDetail?.iconType !== this.iconType.None && this.iconDetail?.popoverMsg) {
            ngbPopover.show();
        } else {
            ngbPopover.hide();
        }
    }

    showTextPopover(ngbPopover: NgbPopover) {
        if(this.showValuePopover) {
            ngbPopover.open();
        }
    }

    hideTextPopover(ngbPopover: NgbPopover) {
        if(this.showValuePopover) {
            ngbPopover.close();
        }
    }
}
